import { Create, getValueFromEvent, useFileUploadState, useForm, useSelect } from "@refinedev/antd";
import { SafetyCertificateOutlined, InboxOutlined, CloudServerOutlined } from "@ant-design/icons";
import { Form, Select, Tag, Upload, Space } from "antd";
import { IResourceComponentsProps, useApiUrl, useNotification } from "@refinedev/core";

import { IVessel, IVesselCertificates } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";
import React from "react";

export const VesselCertificatesCreate: React.FC<
  IResourceComponentsProps
> = () => {
  const [isVesselSelected, setIsVesselSelected] = React.useState(false);
  const [isFileUploaded, setIsFileUploaded] = React.useState(false);

  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IVesselCertificates>({ redirect: "list" });

  const { onChange, isLoading: isFileUploading } = useFileUploadState();
  const apiUrl = useApiUrl();

  const { selectProps: vesselSelectProps } = useSelect<IVessel>({
    resource: "vessel",
    optionLabel: "name",
    optionValue: "id",

    pagination: {
      mode: "server"
    }
  });

  function onVesselSelection(e: any) {
    setIsVesselSelected(true);
  }

  function onFileUpload(e: any) {
    setIsFileUploaded(true);
    onChange(e);
  }

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    action: `${apiUrl}/upload/vessel/certificates`,
    onChange: onFileUpload,
  };

  const { open } = useNotification();

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={{
        ...saveButtonProps,
        disabled:
          isVesselSelected && isFileUploaded && !isFileUploading ? false : true,
      }}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Vessel Certificates",
        subTitle: "setup new vessel certificates",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical" initialValues={{}}>
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Vessel Selection"
            subtitle="Select vessel for certificates"
            icon={<CloudServerOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={1}>
              <Form.Item
                label="Vessel"
                name={["vessel", "id"]}
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select {...vesselSelectProps} onSelect={onVesselSelection} />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
          <FormSection
            title="File Upload"
            subtitle="Upload vessel certificate (PDF only)"
            icon={<SafetyCertificateOutlined />}
            variant="elevated"
          >
            <Form.Item
              name="file"
              valuePropName="file"
              getValueFromEvent={getValueFromEvent}
            >
              <Upload.Dragger
                {...props}
                listType="picture"
                beforeUpload={(file) => {
                  if (file.type !== "application/pdf") {
                    open?.({
                      type: "error",
                      message: "Invalid file type",
                      description: "Only PDF files are supported",
                      key: Date.now().toString(),
                    });
                    return Upload.LIST_IGNORE;
                  }
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag & drop file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single upload of standard library publications for
                  vessel
                </p>
              </Upload.Dragger>
            </Form.Item>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
